var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19629 32C2.30029 31.7201 2.34429 31.248 2.52029 31.196C4.76029 30.492 5.52829 28.584 6.22031 26.668C9.11631 18.668 11.9643 10.652 14.8363 2.648C15.1123 1.876 15.4283 1.116 15.8603 0C15.9111 0 16.3244 0.85609 16.413 1.09225C16.5015 1.32842 22.5923 17.868 25.4883 26.144C26.2443 28.3081 26.7523 30.6321 29.5243 31.1881C29.6643 31.216 29.7123 31.7161 29.8043 32H19.5483C19.7803 31.692 19.9683 31.1721 20.2523 31.112C22.2443 30.68 22.2763 29.3361 21.8563 27.8001C21.3923 26.1001 20.9203 24.396 20.3083 22.748C20.1403 22.296 19.4683 21.748 19.0163 21.7361C15.9523 21.648 12.8803 21.6881 9.74427 21.6881C9.0323 23.796 8.37228 25.836 7.64827 27.856C7.07227 29.4641 7.39628 30.492 9.20428 30.9201C9.68428 31.032 10.0563 31.628 10.4763 32H2.19629ZM19.2643 20.084C17.8083 15.984 16.4363 12.112 14.8683 7.68798C13.2923 12.16 11.9083 16.068 10.4963 20.084H19.2683H19.2643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmatic);
export default __webpack_public_path__ + "static/media/amatic.d8b5c89179880bce0f54d90ca5e4138e.svg";
export { ForwardRef as ReactComponent };